var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhotoGallery = function SvgPhotoGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.666h13.334l-4.6-6-3.067 4L15.6 14 12 18.666ZM10.667 24a2.568 2.568 0 0 1-1.883-.784A2.568 2.568 0 0 1 8 21.334v-16c0-.733.261-1.36.784-1.883a2.568 2.568 0 0 1 1.883-.784h16c.733 0 1.361.262 1.883.784.523.522.784 1.15.784 1.883v16c0 .734-.261 1.361-.784 1.884a2.568 2.568 0 0 1-1.883.783h-16Zm0-2.667h16v-16h-16v16Zm-5.333 8a2.568 2.568 0 0 1-1.884-.783 2.568 2.568 0 0 1-.783-1.884V8h2.667v18.666H24v2.667H5.334Z",
    fill: "#F92"
  }))));
};
export default SvgPhotoGallery;